import { A11yChild } from "../../../../a11y";
import { OptionLabel } from "./option-label";
import { OptionProps } from "./types";
import styles from "./styles.module.scss";

export const Option = ({
  dataTestId,
  searchValue,
  option,
  hasA11yFocus,
  a11yChildRef,
  onClick,
}: OptionProps) => {
  const handleClick = () => {
    onClick(option);
  };

  const { label, content } = option;

  const contentNode = content ?? (
    <OptionLabel
      label={label}
      searchValue={searchValue}
      dataTestId={dataTestId}
    />
  );

  return (
    <A11yChild hasA11yFocus={hasA11yFocus} a11yChildRef={a11yChildRef}>
      <li
        onClick={handleClick}
        data-test-id={dataTestId}
        className={styles.option}
      >
        {contentNode}
      </li>
    </A11yChild>
  );
};
